import styled from 'styled-components';
import { spaceM } from '@xingternal/tokens';
const ErrorContainer = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 150px;
  text-align: center;
`;
const ErrorIconContainer = styled.div `
  margin-bottom: ${spaceM};
`;
const LoadingContainer = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 150px;
`;
const LoadingIconContainer = styled.div `
  margin-bottom: ${spaceM};
`;
export const Styled = {
    ErrorContainer,
    ErrorIconContainer,
    LoadingContainer,
    LoadingIconContainer,
};
//# sourceMappingURL=common.style.js.map